"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RepeaterTable = void 0;
/* eslint-disable sonarjs/cognitive-complexity */
var lodash_1 = require("lodash");
var react_1 = __importStar(require("react"));
var react_feather_1 = require("react-feather");
var react_modal_1 = __importDefault(require("react-modal"));
var form_manager_1 = require("../../form-manager");
var label_1 = require("../label");
var use_create_repeater_1 = require("./use-create-repeater");
var _RepeaterTable = function (_a) {
    var _b, _c;
    var children = _a.children, description = _a.description, data = _a.data, renderer = _a.renderer, dataTestId = _a["data-testid"], formManager = _a.formManager, name = _a.name, repetitionSingularTitle = _a.repetitionSingularTitle, form = _a.form;
    var repeater = (0, use_create_repeater_1.useCreateRepeater)(repetitionSingularTitle, {
        initialData: data,
        renderer: renderer,
        formManager: formManager,
        name: name,
        form: form,
    });
    var _d = (0, react_1.useState)(false), isModalOpen = _d[0], setIsModalOpen = _d[1];
    var _e = (0, react_1.useState)(false), isFullScreenModalOpen = _e[0], setIsFullScreenModalOpen = _e[1];
    var _f = (0, react_1.useState)(null), editIndex = _f[0], setEditIndex = _f[1];
    var _g = (0, react_1.useState)("100%"), tableWidth = _g[0], setTableWidth = _g[1];
    var _h = (0, react_1.useState)(false), isReadyToRender = _h[0], setIsReadyToRender = _h[1];
    (0, react_1.useEffect)(function () {
        var updateWidth = function () {
            var currentElement = document.querySelector(".repeater-table-container");
            if (currentElement) {
                var formElement = currentElement.closest("form");
                if (formElement) {
                    var paddingOffset = 34;
                    var formWidth = formElement.offsetWidth - paddingOffset;
                    setTableWidth(formWidth + "px");
                    setIsReadyToRender(true);
                }
            }
        };
        updateWidth(); // Call immediately to get width before first paint
        window.addEventListener("resize", updateWidth);
        return function () {
            window.removeEventListener("resize", updateWidth);
        };
    }, []);
    var onOpenModal = function () {
        setIsModalOpen(true);
    };
    var onCloseModal = function () {
        setEditIndex(null);
        setIsModalOpen(false);
    };
    var onEdit = function (index) {
        if (confirm("Are you sure you want to edit this item?")) {
            setEditIndex(index);
            setIsModalOpen(true);
        }
    };
    var onDelete = function (index) {
        if (confirm("Are you sure you want to delete this item?")) {
            repeater.remove(index);
        }
    };
    var onAdd = function () {
        if (confirm("Are you sure you want to add a new item?")) {
            repeater.addWithValues(repeater.internalFormManager.formData);
            onOpenModal();
        }
    };
    var calculateColumnWidth = function (question) {
        var maxWidth = 500;
        var baseWidth = 150;
        var widthPerChar = 10;
        var additionalWidth = question.length * widthPerChar;
        var newWidth = Math.max(baseWidth, additionalWidth);
        return newWidth > maxWidth ? maxWidth : newWidth;
    };
    var repeaterAnswers = (0, lodash_1.get)(formManager === null || formManager === void 0 ? void 0 : formManager.repeatedFormData, name, []);
    var addOrEditIndex = (0, lodash_1.isNumber)(editIndex)
        ? editIndex
        : repeater.repetitions.length - 1;
    var content = (_c = (_b = form) === null || _b === void 0 ? void 0 : _b.content) !== null && _c !== void 0 ? _c : [];
    var hasAnswers = repeaterAnswers.length > 0;
    var Table = (react_1.default.createElement("table", { className: "divide-y divide-gray-200 border border-gray-300 rounded-md w-full" },
        react_1.default.createElement("thead", { className: "border-b bg-gray-100 border-gray-300" },
            react_1.default.createElement("tr", null, content === null || content === void 0 ? void 0 :
                content.map(function (item, index) {
                    var width = calculateColumnWidth(item.question) + "px";
                    return (react_1.default.createElement("th", { key: index + "-header", className: "px-4 py-4 text-left text-xs font-semibold", style: { minWidth: width, maxWidth: width } }, item.question));
                }),
                react_1.default.createElement("th", { className: "px-4 py-4 text-left text-xs font-semibold sticky right-0 bg-gray-100" }, "Actions"))),
        react_1.default.createElement("tbody", { className: "bg-white divide-y divide-gray-200" }, repeaterAnswers.map(function (repeaterFormData, index) {
            var _a;
            var normalizedAnswers = Object.keys((_a = repeaterFormData === null || repeaterFormData === void 0 ? void 0 : repeaterFormData.formData) !== null && _a !== void 0 ? _a : {}).reduce(function (acc, key) {
                var normalizedKey = (0, form_manager_1.removeSuffix)(key);
                acc[normalizedKey] = repeaterFormData.formData[key];
                return acc;
            }, {});
            var isFirst = index === 0;
            var isLast = repeater.repetitions.length === index + 1;
            return (react_1.default.createElement("tr", { key: index + "-row-answers", className: "border-b border-gray-300" },
                content.map(function (item, itemIndex) {
                    var value = normalizedAnswers[item.label] || "";
                    var questionWidth = calculateColumnWidth(item.question);
                    var answerWidth = calculateColumnWidth(value);
                    var width = answerWidth > questionWidth ? answerWidth : questionWidth;
                    var widthPixel = width + "px";
                    return (react_1.default.createElement("td", { key: itemIndex + "-answer-cell", className: "px-4 py-4 whitespace-nowrap text-sm overflow-x-auto text-wrap", style: {
                            minWidth: widthPixel,
                            maxWidth: widthPixel,
                        } }, value ? value : react_1.default.createElement("span", { className: "text-gray-400" }, "-")));
                }),
                react_1.default.createElement("td", { className: "px-4 py-4 whitespace-nowrap text-sm text-gray-500 sticky right-0 bg-gray-100" },
                    react_1.default.createElement("div", { className: "flex items-center space-x-2" },
                        !isFirst && (react_1.default.createElement("button", { className: "fs12 text-right text-gray-500 hover:text-gray-800", type: "button", onClick: function () { return repeater.move(index, "UP"); } },
                            react_1.default.createElement(react_feather_1.ArrowUp, { size: 16 }))),
                        !isLast && (react_1.default.createElement("button", { className: "fs12 text-right text-gray-500 hover:text-gray-800", type: "button", onClick: function () { return repeater.move(index, "DOWN"); } },
                            react_1.default.createElement(react_feather_1.ArrowDown, { size: 16 }))),
                        react_1.default.createElement("button", { className: "fs12 text-right text-gray-500 hover:text-gray-800", type: "button", onClick: function () { return onDelete(index); } },
                            react_1.default.createElement(react_feather_1.Trash2, { size: 16 })),
                        react_1.default.createElement("button", { className: "fs12 text-right text-gray-500 hover:text-gray-800", type: "button", onClick: function () { return onEdit(index); } },
                            react_1.default.createElement(react_feather_1.Edit, { size: 16 }))))));
        }))));
    var AddItemCta = (react_1.default.createElement("button", { type: "button", onClick: onAdd, className: "px-6 py-2 text-white bg-visto hover:bg-gray-600 active:bg-gray-200 disabled:bg-opacity-50 rounded-3xl font-bold fs14" }, "Add Item"));
    var Heading = (react_1.default.createElement("div", null,
        react_1.default.createElement(label_1.Label, { style: {
                paddingLeft: 0,
                paddingTop: 0,
                backgroundColor: "transparent",
            }, isFocused: true, className: "font-bold fs16 leading-snug" }, children),
        description && react_1.default.createElement("p", { className: "mt-1 fs14" }, description)));
    var Empty = (react_1.default.createElement("div", { className: "bg-gray-100 rounded-md p-4" },
        react_1.default.createElement("p", { className: "text-center text-gray-400 text-md" }, "No items added, add your first item below.")));
    return (react_1.default.createElement("div", { "data-testid": dataTestId, className: "w-full p-4 bg-white border rounded-md border-gray-200 repeater-table-container" }, isReadyToRender && (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "mb-4 flex justify-between items-start" },
            Heading,
            react_1.default.createElement("button", { type: "button", className: "text-gray-400 hover:text-gray-800", onClick: function () { return setIsFullScreenModalOpen(true); } },
                react_1.default.createElement(react_feather_1.Maximize2, null))),
        hasAnswers ? (react_1.default.createElement("div", { style: { overflowX: "auto", width: tableWidth } }, Table)) : (react_1.default.createElement(react_1.default.Fragment, null, Empty)),
        react_1.default.createElement("div", { className: "mt-4 flex justify-center" }, AddItemCta),
        isModalOpen && (react_1.default.createElement(react_modal_1.default, { isOpen: isModalOpen, onRequestClose: onCloseModal, portalClassName: "RepeaterTableEditModal" },
            react_1.default.createElement("div", { className: "mb-4" },
                react_1.default.createElement("h2", { className: "text-center mb-1 text-2xl" },
                    (0, lodash_1.isNumber)(editIndex) ? "Edit" : "Add",
                    " Item"),
                react_1.default.createElement("p", { className: "text-center" }, "Changes will automatically be saved as a draft")),
            repeater.render(repeater.repetitions[addOrEditIndex], repeater.getRepetitionFormData(addOrEditIndex)),
            react_1.default.createElement("div", { className: "flex justify-center mt-5 sticky bottom-0" },
                react_1.default.createElement("button", { onClick: onCloseModal, className: "px-6 py-2 text-white bg-visto hover:bg-gray-600 active:bg-gray-200 disabled:bg-opacity-50 rounded-3xl font-bold fs14" },
                    "Done ",
                    (0, lodash_1.isNumber)(editIndex) ? "Editing" : "Adding",
                    " Item")))),
        isFullScreenModalOpen && (react_1.default.createElement(react_modal_1.default, { isOpen: isFullScreenModalOpen, onRequestClose: function () { return setIsFullScreenModalOpen(false); }, portalClassName: "RepeaterTableFullScreenModal" },
            react_1.default.createElement("div", null,
                react_1.default.createElement("div", { className: "mb-3" }, Heading),
                hasAnswers ? (react_1.default.createElement("div", { className: "overflow-auto" }, Table)) : (react_1.default.createElement("div", { className: "w-full" }, Empty)),
                react_1.default.createElement("div", { className: "flex justify-center flex-col items-center mt-5 sticky bottom-0" },
                    AddItemCta,
                    react_1.default.createElement("button", { onClick: function () { return setIsFullScreenModalOpen(false); }, className: "mt-2 font-bold fs14" }, "Close")))))))));
};
var RepeaterTable = function (_a) {
    var formManager = _a.formManager, name = _a.name, form = _a.form, props = __rest(_a, ["formManager", "name", "form"]);
    return (react_1.default.createElement(_RepeaterTable, __assign({ data: formManager._initialData, formManager: formManager, name: name, form: form }, props)));
};
exports.RepeaterTable = RepeaterTable;
